/**
 * Asterlane Press Page - Modal Functionality
 * Handles press release modal display
 */

(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const modal = document.getElementById('pressModal');
    const modalContent = document.getElementById('modalContent');
    const pressCards = document.querySelectorAll('.press-card--clickable');
    const closeButtons = document.querySelectorAll('[data-modal-close]');
    
    if (!modal || !modalContent) {
      console.warn('Press modal elements not found');
      return;
    }
    
    // Load article data from JSON
    let articlesData = {};
    try {
      const dataElement = document.getElementById('pressArticlesData');
      if (dataElement) {
        const data = JSON.parse(dataElement.textContent);
        data.articles.forEach(article => {
          articlesData[article.id] = article;
        });
      }
    } catch (e) {
      console.error('Failed to parse press data:', e);
    }
    
    // Add click handlers
    pressCards.forEach(card => {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(this.dataset.articleId);
      });
      
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(this.dataset.articleId);
        }
      });
    });
    
    // Close handlers
    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeModal);
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
    
    /**
     * Open modal with article content
     */
    function openModal(articleId) {
      const article = articlesData[articleId];
      
      if (!article) {
        console.error('Article not found:', articleId);
        return;
      }
      
      modalContent.innerHTML = buildModalContent(article);
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      
      const closeBtn = modal.querySelector('.press-modal__close');
      if (closeBtn) closeBtn.focus();
      
      // Track event
      if (typeof gtag !== 'undefined') {
        gtag('event', 'press_view', {
          'publication': article.publication,
          'headline': article.headline
        });
      }
    }
    
    /**
     * Close modal
     */
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      modalContent.innerHTML = '';
    }
    
    /**
     * Build modal HTML content
     */
    function buildModalContent(article) {
      let html = '<div class="modal-article">';
      
      // Header
      html += '<div class="modal-article__header">';
      html += `<p class="modal-article__publication">${escapeHtml(article.publication)}</p>`;
      html += `<h1 class="modal-article__title">${escapeHtml(article.headline)}</h1>`;
      html += `<p class="modal-article__date">${escapeHtml(article.date)}</p>`;
      html += '</div>';
      
      // Image (if no PDF)
      if (article.image && !article.pdf_url) {
        html += `<img src="${escapeHtml(article.image)}" alt="${escapeHtml(article.headline)}" class="modal-article__image">`;
      }
      
      // PDF Viewer
      if (article.pdf_url) {
        html += `<iframe src="${escapeHtml(article.pdf_url)}" class="modal-pdf-viewer" title="Press Article PDF"></iframe>`;
      }
      
      // Content
      if (article.content) {
        html += `<div class="modal-article__content">${article.content}</div>`;
      } else if (article.summary) {
        html += `<div class="modal-article__content">${escapeHtml(article.summary)}</div>`;
      }
      
      // Action buttons
      html += '<div class="modal-article__actions">';
      
      if (article.pdf_url) {
        html += `
          <a href="${escapeHtml(article.pdf_url)}" download class="modal-btn" target="_blank">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Download PDF
          </a>
        `;
      }
      
      if (article.external_link) {
        html += `
          <a href="${escapeHtml(article.external_link)}" class="modal-btn modal-btn--secondary" target="_blank" rel="noopener noreferrer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
            View Original
          </a>
        `;
      }
      
      html += '</div></div>';
      
      return html;
    }
    
    /**
     * Escape HTML to prevent XSS
     */
    function escapeHtml(unsafe) {
      if (!unsafe) return '';
      return unsafe
        .toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }
  }
})();